<div role="main" class="container" #animationRoot>
  <div class="jumbotron">
    <h1 class="it-works text-{{themeVariant}}">{{text}}</h1>
  </div>
</div>
